import { SelectOption } from '../../classes'

export enum AuthorizationRuleAPI {
  AVAILITY = 'availity',
  CARELON = 'carelon',
  EVICORE = 'evicore',
  OPTUM = 'optum',
}

export enum AuthorizationRuleAPIActionType {
  PULL_AUTHORIZATION_STATUS = 'pull-status',
  PULL_AUTHORIZATIONS = 'pull-authorizations',
}

export const AuthorizationRuleAPIList: SelectOption<string>[] = [
  {
    value: AuthorizationRuleAPI.AVAILITY,
    viewValue: 'authorization-rules.api.availity',
  },
  {
    value: AuthorizationRuleAPI.EVICORE,
    viewValue: 'authorization-rules.api.evicore',
  },
  {
    value: AuthorizationRuleAPI.OPTUM,
    viewValue: 'authorization-rules.api.optum',
  },
]

export const getAuthorizationRuleAPIName = (value: AuthorizationRuleAPI): string => {
  return AuthorizationRuleAPIList.find((item) => item.value === value)?.viewValue || value
}
